import React from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import CardImg from "../../../../components/CardImg";

/**
 * Race to 2nd (casino/race2) card overlay — reference markup:
 * .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container
 *   > 4 × div > (.dealer-name.w-100.mb-1 > span(nat)) + div > span > img (one per dealt card)
 * The card string is dealt round-robin to Player A..D (slot 1..4 repeating); "1" = not dealt
 * (the slot still advances). `subData` = the race2 markets ordered by sr (their nat is the label).
 */
export default function Race2CardsOverlay({ cardString, subData = [], showCards = true, onToggle }) {
  const str = String(cardString ?? "");
  if (!str) return null;
  const cards = str.split(",").map((c) => c.trim());
  const groups = [[], [], [], []];
  cards.forEach((token, idx) => {
    if (token !== "1" && token !== "") groups[idx % 4].push(token);
  });
  const firstCard = cards[0];
  const hidden = !showCards || firstCard === "1";

  return (
    <div className={`casino-video-cards${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => firstCard !== "1" && onToggle && onToggle()}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        {groups.map((group, i) => (
          <React.Fragment key={i}>
            {i > 0 && " "}
            <div>
              <div className="dealer-name w-100 mb-1">
                <span>{subData[i]?.nat ?? `Player ${"ABCD"[i]}`}</span>
              </div>{" "}
              <div>
                {group.map((token, ci) => (
                  <span key={ci}>
                    <CardImg src={getCardImage(token)} />
                  </span>
                ))}
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
